import styled from "styled-components";

export const colors = { yellow: "#e4b940", red: "#7a231d", dark: "#201712" };

export const NavbarKujipy = styled.nav`
  position: sticky;
  top: 0;
  z-index: 1000;
  background: rgba(244, 232, 194, 0.96);
  border-bottom: 1px solid rgba(122, 35, 29, 0.25);
  backdrop-filter: blur(14px);
`;

export const NavbarInner = styled.div`
  width: min(100% - 2rem, 1240px);
  min-height: 72px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 1.5rem;
`;

export const NavbarLogoStyle = styled.div`
  display: flex;
  img { display: block; height: 44px; width: auto; border-radius: 50%; }
`;

export const NavbarElementsStyle = styled.div`
  display: flex;
  justify-content: center;
  gap: clamp(.8rem, 1.5vw, 1.65rem);
  .game-nav-link { color: ${colors.red}; font-size: .82rem; font-weight: 800; letter-spacing: .1em; text-decoration: none; text-transform: uppercase; }
  @media (max-width: 1120px) { display: none; }
`;

export const NavbarRight = styled.div`
  display: flex;
  align-items: center;
  gap: .8rem;
  @media (max-width: 1120px) { display: none; }
`;

export const NavbarLang = styled.div`
  display: flex;
  gap: .25rem;
  button {
    min-width: 38px; min-height: 38px; border: 0; border-radius: 999px;
    background: transparent; color: ${colors.dark}; cursor: pointer;
    font: inherit; font-size: .72rem; font-weight: 800; letter-spacing: .08em;
  }
  button:hover, button.active { background: ${colors.red}; color: white; }
`;

export const MobileActions = styled.div`
  display: none;
  justify-self: end;
  align-items: center;
  gap: .35rem;
  @media (max-width: 1120px) { display: flex; }
`;

export const HamburgerButton = styled.button`
  width: 44px; height: 44px; padding: 0; display: grid; place-items: center;
  border: 1px solid rgba(32, 23, 18, .2); border-radius: 50%;
  background: transparent; color: ${colors.dark}; font-size: 1.3rem; cursor: pointer;
`;

export const MobileMenu = styled.div<{ $open: boolean }>`
  position: fixed;
  inset: 72px 0 auto;
  max-height: calc(100dvh - 72px);
  overflow-y: auto;
  padding: 1.25rem max(1.25rem, calc((100vw - 700px) / 2));
  display: ${({ $open }) => ($open ? "grid" : "none")};
  gap: .25rem;
  background: #f4e8c2;
  border-bottom: 2px solid ${colors.red};
  box-shadow: 0 18px 40px rgba(32, 23, 18, .15);
  .mobile-lang { display: flex; gap: .5rem; padding-top: .75rem; }
  .game-nav-link { padding: .7rem .25rem; color: ${colors.red}; font-size: .85rem; font-weight: 800; letter-spacing: .14em; text-decoration: none; text-transform: uppercase; }
  .mobile-lang button { min-height: 40px; padding: 0 1rem; border: 1px solid ${colors.red}; border-radius: 999px; background: transparent; }
  .mobile-lang button.active { background: ${colors.red}; color: white; }
  @media (min-width: 1121px) { display: none; }
`;
